'use client';

import { ILocalAddress, useData } from '@/components';
import { useEcomStoreSelector } from '@/data';
import { Store } from '@/types';
import { isDeliveryAddressOutOfZone } from '@/utils';

export function useDeliveryAddressZone(): boolean {
  const { store, treezStores } = useData();
  const { delivery_address, delivery_details, treez_store_name } =
    useEcomStoreSelector([
      'delivery_address',
      'delivery_details',
      'treez_store_name',
    ]);

  if (delivery_details?.pickup) return false;

  return isDeliveryAddressOutOfZone(
    delivery_address as ILocalAddress,
    store as Store,
    treezStores,
    treez_store_name,
  );
}
